import React from 'react';

const LoadingBar = (props) => {
  return <div className="loading-bar"></div>
}

export default LoadingBar;
